import React from 'react';
import { ArrowRight, FileText } from 'lucide-react';

const ServicesHero = () => {
  return (
    <section id="services-hero" className="pt-24 pb-20 bg-white">
      <div className="container-center">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Header */}
          <div className="space-y-6">
            <h1 className="font-display text-5xl lg:text-6xl font-bold text-olive-brown leading-tight">
              What we handle (and how we work).
            </h1>
            
            <p className="text-xl text-olive-brown/80 leading-relaxed">
              FractionalVa supports leaders with the daily operations that steal time: 
              communication, scheduling, follow-through, coordination, and admin structure.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
            <a
              href="#contact"
              className="btn-primary group inline-flex items-center justify-center"
              aria-label="Book a Quick Call - We'll recommend the right level of support"
            >
              Book a Quick Call
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
            </a>
            <a
              href="#contact"
              className="btn-secondary group inline-flex items-center justify-center"
              aria-label="Request a Confidential Memo - Written plan based on your role and workload"
            >
              Request a Confidential Memo
              <FileText className="ml-2 h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
            </a>
          </div>

          {/* Microcopy */}
          <div className="text-center space-y-2 pt-4">
            <p className="text-sm text-olive-brown/60">
              <strong>Primary:</strong> We'll recommend the right level of support.
            </p>
            <p className="text-sm text-olive-brown/60">
              <strong>Secondary:</strong> Written plan based on your role and workload.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;